import { fetchError, fetchStart, fetchSuccess } from "../../redux/actions";
import {
  setAllMedia,
  setMediaCurrentPage,
  setTotalMediaPages,
  setloadingRemoveMedia,
  setRemovedMediaId,
  getAllGalleries,
  setGalleryCurrentPage,
  setTotalGalleryPage,
} from "../../redux/actions/Media";

import axios from "../auth/jwt/config";

const MediaRequests = {
  getmediaList: (page) => {
    return (dispatch) => {
      try {
        dispatch(fetchStart());
        axios
          .get(`/file/getall?page=${page}&limit=50`)
          .then(({ data }) => {
            dispatch(fetchSuccess());
            dispatch(setAllMedia(data.data.docs));
            dispatch(setMediaCurrentPage(data.data.page));
            dispatch(setTotalMediaPages(data.data.totalPages));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msg));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  deleteMedia: (mediaId) => {
    return (dispatch) => {
      try {
        dispatch(setloadingRemoveMedia(true));
        axios
          .delete(`/file/delete/${mediaId}`)
          .then(() => {
            dispatch(fetchSuccess("با موفقیت حذف شد"));
            dispatch(setRemovedMediaId(mediaId));
            dispatch(setloadingRemoveMedia(false));
          })
          .catch((error) => {
            dispatch(setloadingRemoveMedia(false));
            if (error.response) {
              dispatch(fetchError(error.response.data.msg));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(setloadingRemoveMedia(false));
        dispatch(fetchError(error.message));
      }
    };
  },
  createGallery: (galleryData) => {
    return (dispatch) => {
      try {
        dispatch(fetchStart());
        axios
          .post(`/gallery/create`, galleryData)
          .then(() => {
            dispatch(fetchSuccess("گالری رخداد با موفقیت ساخته شد."));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msg));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  getAllGalleies: (page) => {
    return (dispatch) => {
      try {
        dispatch(fetchStart());
        axios
          .get(`/gallery/getall?page=${page}&limit=2`)
          .then(({ data }) => {
            dispatch(fetchSuccess());
            dispatch(getAllGalleries(data.docs));
            dispatch(setGalleryCurrentPage(data.page));
            dispatch(setTotalGalleryPage(data.totalPages));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msg));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  DeleteGallery: (id) => {
    return (dispatch) => {
      try {
        dispatch(fetchStart());
        axios
          .delete(`/gallery/delete/${id}`)
          .then(() => {
            dispatch(fetchSuccess("با موفقیت حذف شد"));
            MediaRequests.getAllGalleies()(dispatch);
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msg));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  updateGallery: (id, data) => {
    return (dispatch) => {
      try {
        dispatch(fetchStart());
        axios
          .patch(`/gallery/update/${id}`, data)
          .then(() => {
            dispatch(fetchSuccess("با موفقیت به‌روزرسانی شد"));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msg));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
};

export default MediaRequests;
